'use client';

import TechstackDetailCompanies from '@/features/Techstack/components/TechstackDetailCompanies';
import TechstackDetailHeader from '@/features/Techstack/components/TechstackDetailHeader';
import TechstackDetailJobpost from '@/features/Techstack/components/TechstackDetailJobpost';
import TechstackDetailRelativeTechstacks from '@/features/Techstack/components/TechstackDetailRelativeTechstacks';
import TechstackDetailTechblog from '@/features/Techstack/components/TechstackDetailTechblog';
import { mixpanelTrack } from '@/utils/mixpanel';
import { sendGTMEvent } from '@next/third-parties/google';
import { useEffect } from 'react';

const TechstackDetailPage = ({
  id,
  techstack,
}: {
  id: string;
  techstack: any;
}) => {
  useEffect(() => {
    mixpanelTrack('TechstackDetailPage', 'Viewed', { id: id });
    sendGTMEvent({ event: 'page__view' });
  }, []);

  return (
    <>
      <TechstackDetailHeader data={techstack} />
      <TechstackDetailCompanies data={techstack} />
      <TechstackDetailTechblog data={techstack} />
      <TechstackDetailRelativeTechstacks data={techstack} />
      <TechstackDetailJobpost data={techstack} />
    </>
  );
};

export default TechstackDetailPage;
